import { render } from "./CreateBankAccount.vue?vue&type=template&id=7b42421c"
import script from "./CreateBankAccount.vue?vue&type=script&lang=js"
export * from "./CreateBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__